<label class="radio" (mouseup)="toggle()">
    <input type="radio"
           [attr.value]="option.value"
           [attr.name]="name"
           [checked]="isInitChecked()" />
    <span>{{ option.label | uppercase | translate }}</span>
</label>
